import { CodeNode, CodeHighlightNode } from './code.js';
import { LinkNode, AutoLinkNode } from './link.js';
import { ListItemNode, ListNode } from './list.js';
import { MentionNode } from './mention.js';
import { HeadingNode, QuoteNode } from './rich-text.js';

export const makePostLexicalNodes = () => {
  return [
    LinkNode,
    AutoLinkNode,
    MentionNode,
    HeadingNode,
    QuoteNode,
    CodeNode,
    CodeHighlightNode,
    ListNode,
    ListItemNode,
  ];
};
